import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { getDataRequest } from "../../api/serviceMethods";
import { PAYMENT_URL, TEACHER_URL } from "../../api/URLs";
import TablePaymentCourse from "./TablePaymentCourse";

const TableMainCoursePurchasePage = ({ setLoading, messageModalRef }) => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const queryCourseId = searchParams.get('courseId') || searchParams.get('courseNo') || searchParams.get('keyword') || searchParams.get('id') || '';
    const [dates, setDates] = useState([null, null]);
    const [paymentData, setPaymentData] = useState([])
    const [memberType, setMemberType] = useState('course');
    const [keyword, setKeyword] = useState(queryCourseId);
    const [teachers, setTeachers] = useState([]);
    const [dataObject, setDataObject] = useState({
        type: "",
        method: "",
        teacherId: ""
    })
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    });

    const fetchTeachers = async () => {
        try {
            const res = await getDataRequest(`${TEACHER_URL}`, { pageSize: 1000 });
            if (res.status === 200 && res.data) {
                const options = res.data.map(item => ({
                    label: item.name,
                    value: item._id
                }));
                setTeachers(options);
            }
        } catch (err) {
            console.error("Error fetching teachers:", err);
        }
    };

    useEffect(() => {
        fetchTeachers();
    }, []);

    useEffect(() => {
        const currentCourseId = searchParams.get('courseId') || searchParams.get('courseNo') || searchParams.get('keyword') || searchParams.get('id') || '';
        setKeyword(currentCourseId);
    }, [searchParams]);

    const initLoadPayment = async () => {
        setLoading(true);
        const currentCourseId = searchParams.get('courseId') || searchParams.get('courseNo') || searchParams.get('id') || '';
        const searchKeyword = (keyword || '').trim();

        const params = {
            keyword: searchKeyword,
            startDate: dates[0] || "",
            endDate: dates[1] || "",
            paymentType: dataObject.type,
            paymentMethod: dataObject.method,
            orderType: memberType,
            pageNo: tableParams.pagination.current,
            sortKeys: { [tableParams.sortField ? tableParams.sortField : "time"]: tableParams.sortOrder === "ascend" ? "asc" : "desc" },//descend
            pageSize: tableParams.pagination.pageSize,
        };

        if (currentCourseId) {
            params.courseId = currentCourseId;
        }

        if (dataObject.teacherId) {
            params.teacherId = dataObject.teacherId;
        }

        await getDataRequest(`${PAYMENT_URL}`, params).then(res => {
            setLoading(false);
            if (res.status === 200) {
                setPaymentData(res?.data);
                setTableParams({
                    ...tableParams,
                    pagination: {
                        ...tableParams.pagination,
                        total: res.total,
                    },
                });
            }
        }).catch((err) => {
            setLoading(false);
            console.log("Error", err);
        });
    };
    const [isSearch, setIsSearch] = useState(true)
    useEffect(() => {
        isSearch && initLoadPayment();
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sortOrder,
        tableParams?.sortField,
        JSON.stringify(tableParams.filters),
        isSearch,
        memberType,
        searchParams
    ]);

    return (

        <TablePaymentCourse
            messageModalRef={messageModalRef}
            paymentData={paymentData}
            keyword={keyword}
            setKeyword={setKeyword}
            teachers={teachers}
            tableParams={tableParams}
            setTableParams={setTableParams}
            dates={dates}
            setDates={setDates}
            initLoadPayment={() => {
                setIsSearch(false)
                setTimeout(() => {
                    setIsSearch(true)
                }, 100);
            }}
            memberType={memberType}
            dataObject={dataObject}
            setDataObject={setDataObject}
        />
    );
};

export default TableMainCoursePurchasePage;
